// src/context/useTheme.ts
export type Theme = "device" | "white" | "light" | "dark";

export function useTheme() {
  const getTheme = (): Theme =>
    (localStorage.getItem("theme") as Theme) || "device";

  const applyTheme = (theme: Theme): Theme => {
    // Always set the raw theme (device, white, light, dark)
    document.documentElement.setAttribute("data-theme", theme);
    return theme;
  };

  const toggleTheme = (): Theme => {
    const themes: Theme[] = ["device", "white", "light", "dark"];
    const current = getTheme();
    const next = themes[(themes.indexOf(current) + 1) % themes.length];

    localStorage.setItem("theme", next);
    return applyTheme(next);
  };

  return { theme: getTheme(), toggleTheme, applyTheme };
}
